export default {
  dbi_pagination_total: '总共 {total} 条',
};
